// Getters cho module navigation
export default {
	/**
	 * Lấy flag điều hướng Bảng kê hiện tại
	 * Trả về null nếu không có flag, hoặc { reportType: 'summary' | 'detail' } nếu có
	 * @param {Object} state - State hiện tại của module
	 * @returns {Object|null} Flag điều hướng hoặc null
	 */
	bangKeNavigation: state => state.bangKeNavigation
};